module.exports = __webpack_public_path__ + "static/media/G1-20-Lorena-Pallas-cod40.a8b6471f.png";